import React from "react"
import { Formik, Form } from "formik"
import { InputFieldWithLabel } from "@components/Form/Fields"
import { Button } from "@components/Button"
import { Modal } from "@UILibrary/Modal"
import { PhoneFieldWithLabel } from "./PhoneFieldWithLabel"
import { inviteValidationSchema } from "./inviteValidation"

export type InviteFormValues = {
  first_name: string
  last_name: string
  email: string
  cellphone_number: string
}

const BLANK: InviteFormValues = {
  first_name: "",
  last_name: "",
  email: "",
  cellphone_number: "",
}

type Props = {
  title: string
  open: boolean
  onClose: () => void
  onSubmit: (values: InviteFormValues) => Promise<void>
  submitting: boolean
}

// Invite form for both wealth managers and paraplanners. Uses the shared Modal
// shell plus the app's Formik form fields (@components/Form/Fields) and Button —
// same design-system pieces the Scenario page uses. Validation is Yup (see
// inviteValidation); the backend (phony_plausible) stays authoritative and its
// errors surface in the form-level notice.
export const InviteModal: React.FC<Props> = ({ title, open, onClose, onSubmit, submitting }) => (
  <Modal open={open} title={title} onClose={onClose}>
    <Formik
      initialValues={BLANK}
      validationSchema={inviteValidationSchema}
      onSubmit={async (values, { setStatus }) => {
        setStatus(null)
        try {
          await onSubmit(values)
          onClose()
        } catch (err: any) {
          setStatus(err?.message || "Something went wrong")
        }
      }}
    >
      {({ status }) => (
        <Form className="fsp-admin__form app-form">
          <div className="fsp-admin__form-row">
            <InputFieldWithLabel name="first_name" label="First name" autoFocus />
            <InputFieldWithLabel name="last_name" label="Last name" />
          </div>

          <InputFieldWithLabel name="email" label="Email" type="email" />
          <PhoneFieldWithLabel name="cellphone_number" label="Cellphone number" />

          {status && <div className="fsp-admin__notice fsp-admin__notice--error">{status}</div>}

          <div className="fsp-admin__modal-actions">
            <Button secondary type="button" onClick={onClose}>Cancel</Button>
            <Button primary type="submit" disabled={submitting}>
              {submitting ? "Inviting…" : "Send invite"}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  </Modal>
)
